import React from 'react';
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface Reminder {
  id: string;
  medication_id: string;
  reminder_time: string;
  days_of_week: string[];
  is_active: boolean;
}

export default function Reminders() {
  const [reminders, setReminders] = useState<Reminder[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReminders();
  }, []);

  async function fetchReminders() {
    try {
      const { data, error } = await supabase
        .from('reminders')
        .select('*')
        .order('reminder_time');

      if (error) throw error;
      setReminders(data || []);
    } catch (error) {
      console.error('Error fetching reminders:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Medication Reminders</h1>
      
      {loading ? (
        <div className="flex justify-center items-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        </div>
      ) : reminders.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-600">No reminders set yet.</p>
          <button 
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Create New Reminder
          </button>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {reminders.map((reminder) => (
            <div 
              key={reminder.id}
              className="bg-white rounded-lg shadow p-4"
            >
              <div className="flex justify-between items-center mb-2">
                <span className="text-lg font-semibold">
                  {reminder.reminder_time}
                </span>
                <span className={`px-2 py-1 rounded text-sm ${
                  reminder.is_active 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {reminder.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
              <div className="flex gap-1 flex-wrap">
                {reminder.days_of_week.map((day) => (
                  <span 
                    key={day}
                    className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-sm"
                  >
                    {day}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}